import {api} from '../../helpers';

export function getAuditLog(id) {
  return api.get(`/users/audit-trail/${id}`).then(res => res.data);
}

export function getExportLogs(params) {
  return api.get('/exports', {params}).then(res => res.data);
}
